import React from 'react';
import { Box, Typography, Button, Paper, Stack } from '@mui/material';
import { IconArrowRight } from '@tabler/icons-react';
import { colors, fonts } from '../../ColorFont/color';

/**
 * A premium-styled component for restricted or empty states across the application.
 * Ensures UI consistency for pages requiring login, profile completion, or specific roles.
 */
const BlockedView = ({ icon, title, description, buttonText, onAction, sx = {} }) => {
    return (
        <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            minHeight: '60vh',
            px: 2,
            py: 4,
            ...sx
        }}>
            <Paper elevation={0} sx={{
                maxWidth: 500,
                width: '100%',
                p: 4,
                textAlign: 'center',
                borderRadius: '24px',
                border: `1px dashed ${colors.primary_rgba_12 || 'rgba(0,0,0,0.1)'}`,
                background: 'linear-gradient(135deg, #FFFFFF 0%, #FFFFFF 100%)',
                boxShadow: '0 20px 40px rgba(0,0,0,0.04)'
            }}>
                <Stack spacing={3} alignItems="center">
                    <Box sx={{
                        width: 80,
                        height: 80,
                        borderRadius: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        boxShadow: '0 8px 16px rgba(0,0,0,0.05)',
                        mb: 1
                    }}>
                        {icon}
                    </Box>

                    <Box>
                        <Typography variant="h5" sx={{ 
                            fontFamily: fonts.poppins, 
                            fontWeight: 700, 
                            color: '#1C252E',
                            mb: 1
                        }}>
                            {title}
                        </Typography>
                        <Typography sx={{ 
                            fontFamily: fonts.poppins, 
                            color: '#637381',
                            lineHeight: 1.6,
                            fontSize: '15px'
                        }}>
                            {description}
                        </Typography>
                    </Box>

                    <Button
                        variant="contained"
                        onClick={onAction}
                        endIcon={<IconArrowRight size={18} />}
                        sx={{
                            backgroundColor: colors.primary,
                            color: '#FFF',
                            borderRadius: '12px',
                            textTransform: 'none',
                            fontFamily: fonts.poppins,
                            fontWeight: 600,
                            fontSize: '16px',
                            px: 4,
                            py: 1.2,
                            boxShadow: `0 8px 16px ${colors.primary_rgba_12 || 'rgba(0,0,0,0.1)'}`,
                            '&:hover': {
                                backgroundColor: colors.primary_dark,
                                transform: 'translateY(-2px)',
                                transition: 'all 0.2s'
                            }
                        }}
                    >
                        {buttonText}
                    </Button>
                </Stack>
            </Paper>
        </Box>
    );
};

export default BlockedView;
